<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		width="56"
		height="56"
		viewBox="0 0 56 56"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="class"
	>
		<path
			opacity="0.1"
			d="M56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28ZM5.6 28C5.6 40.3712 15.6288 50.4 28 50.4C40.3712 50.4 50.4 40.3712 50.4 28C50.4 15.6288 40.3712 5.6 28 5.6C15.6288 5.6 5.6 15.6288 5.6 28Z"
			fill="currentColor"
		/>
		<path
			d="M28.6729 2.80898C28.7141 1.26314 30.0043 0.0290368 31.5383 0.224447C36.0014 0.792977 40.2764 2.43088 43.992 5.0162C48.4763 8.13634 51.9499 12.5001 53.9849 17.57C56.0199 22.6398 56.5273 28.1941 55.4447 33.5488C54.3621 38.9034 51.7367 43.8244 47.8921 47.7055C44.0474 51.5865 39.1514 54.2582 33.8072 55.3912C28.463 56.5242 22.9041 56.0691 17.8153 54.082C12.7265 52.0949 8.3302 48.6626 5.16793 44.2079C2.54771 40.5168 0.869591 36.2574 0.259026 31.7999C0.0491678 30.2678 1.27106 28.9661 2.81644 28.9102V28.9102C4.36183 28.8544 5.64205 30.0674 5.89014 31.5937C6.43703 34.9583 7.74694 38.1667 9.73434 40.9663C12.2642 44.5301 15.7812 47.2759 19.8522 48.8656C23.9233 50.4553 28.3704 50.8194 32.6457 49.9129C36.9211 49.0065 40.8379 46.8692 43.9137 43.7644C46.9894 40.6595 49.0897 36.7227 49.9558 32.439C50.8218 28.1553 50.4159 23.7118 48.7879 19.656C47.1599 15.6001 44.381 12.1091 40.7936 9.61296C37.9754 7.65203 34.7548 6.37241 31.3852 5.85726C29.8566 5.62356 28.6316 4.35483 28.6729 2.80898V2.80898Z"
			fill="currentColor"
		/>
	</svg>
</template>
